var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAltersversicherung = function SvgAltersversicherung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Altersversicherung_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27 17.75a2.86 2.86 0 1 0 0-5.72 2.86 2.86 0 0 0 0 5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 23.48v-1a4.78 4.78 0 0 1 4.77-4.77 4.78 4.78 0 0 1 4.78 4.77v1M9.14 3.43v5.73a1.91 1.91 0 0 0 1.91 1.91h2.86V13l2.86-1.91h3.82a1.91 1.91 0 0 0 1.91-1.93V3.43a1.91 1.91 0 0 0-1.91-1.91h-9.54a1.91 1.91 0 0 0-1.91 1.91ZM12 6.3h7.64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Altersversicherung_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAltersversicherung;